import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipoParadaComponent } from './tipo-parada.component';
import { TranslateModule } from '@ngx-translate/core';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ComumModule } from '../../../shared/comum.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TipoParadaService } from './tipo-parada-service/tipo-parada.service';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ComumModule,
    TooltipModule,
    DialogModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  declarations: [
    TipoParadaComponent
  ],
  providers: [
    TipoParadaService
  ]
})
export class TipoParadaModule { }
